<template>
  <div>
    <grid-x col="1fr 1fr" row="1fr" gap="2em">
      <div class="col-1">
        <h3>Update Videos</h3>
        <div class="widget-buttons">
          <button v-on:click="updateCacheVideo()">Update Video Cache</button>
        </div>
        <div class="input-box down-caret">
          <select
            v-model="selectedVideo"
            class="video-list-select"
            @change="selected()"
            @focus="changeColor()"
            ref="videoSelector"
          >
            <option disabled value>Select a video</option>
            <option v-for="(item,key) in videos" :key="key" :value="item.title">{{item.title}}</option>
          </select>
        </div>
        <div v-for="(item,key) in videos" :key="key">
          <div v-if="selectedVideo === item.title" class="draggable-items flex center-flex-y">
            <span>{{item.title}}</span>
            <div class="podcast-buttons">
              <button v-on:click="removeVideoItem(item)">Remove</button>
              <button v-on:click="editVideoItem(item)">Edit</button>
            </div>
          </div>
        </div>
        <grid-x class="edit-video" col="1fr 1fr" row="1fr" gap=".5em">
          <div v-if="editVideoMode">
            <div class="input-label">Video Slug</div>
            <div class="input-box">
              <input v-model="editVideo.key" type="text" placeholder="New Video Slug">
            </div>
            <div class="input-label">Video Title</div>
            <div class="input-box">
              <input v-model="editVideo.obj.title" type="text" placeholder="New Video Title">
            </div>
            <div class="input-label">Video ID</div>
            <div class="input-box">
              <input v-model="editVideo.obj.id" type="text" placeholder="New Video ID">
            </div>
            <div class="input-label">SEO Title</div>
            <div class="input-box">
              <input v-model="editVideo.obj.seoTitle" type="text" placeholder="SEO Title">
            </div>
            <div class="input-label">SEO Description</div>
            <div class="input-box">
              <input
                v-model="editVideo.obj.seoDescription"
                type="text"
                placeholder="SEO Description"
              >
            </div>
            <button style="margin-top:20px;float:left;" @click="executeEditVideo">Save Changes</button>
          </div>
          <div v-if="editVideoMode">
            <h3 class="social-image-title">Social Image</h3>
            <img :src="editVideo.obj.socialImage" style="width:100px;height:100px;display:block">
            <ic-firebase-upload
              path="images"
              max-files="1"
              :getFileName="getFileName"
              :storage="storage"
              @uploaded="onUploadedVideoSocialImage"
              @upload="onUpload"
              @delete="onDelete"
            ></ic-firebase-upload>
          </div>
        </grid-x>
      </div>
      <div class="col-2">
        <h3>New Video</h3>
        <div class="widget-buttons">
          <button @click="showNewVideo = !showNewVideo">New Video</button>
        </div>
        <div v-if="showNewVideo">
          <div class="input-label">Video Slug</div>
          <div class="input-box">
            <input
              v-model="newVideo.key"
              type="text"
              placeholder="New Video Slug"
              style="display:block;width:180px;"
            >
          </div>
          <div class="input-label">Video Title</div>
          <div class="input-box">
            <input
              v-model="newVideo.obj.title"
              type="text"
              placeholder="New Video Title"
              style="display:block;width:180px;"
            >
          </div>
          <div class="input-label">Video ID</div>
          <div class="input-box">
            <input
              v-model="newVideo.obj.id"
              type="text"
              placeholder="New Video ID"
              style="display:block;width:180px;"
            >
          </div>
          <div class="input-label">SEO Title</div>
          <div class="input-box">
            <input
              v-model="newVideo.obj.seoTitle"
              type="text"
              placeholder="SEO Title"
              style="display:block;width:180px;"
            >
          </div>
          <div class="input-label">SEO Description</div>
          <div class="input-box">
            <input
              v-model="newVideo.obj.seoDescription"
              type="text"
              placeholder="SEO Description"
              style="display:block;width:180px;"
            >
          </div>
          <div class="input-label">Social Image</div>
          <div class="input-box">
            <input
              v-model="newVideo.obj.socialImage"
              type="text"
              placeholder="Social Image"
              style="display:block;width:180px;"
            >
          </div>
          <button style="margin-top:20px;float:left;" @click="createVideo">Create Video Series Entry</button>
        </div>
      </div>
    </grid-x>
    <div v-if="editVideoMode">
      <h3>All Videos</h3>
      <div
        class="draggable-items all-videos flex center-flex-y"
        v-for="(item,key) in videoEpisodes"
        :key="key"
      >
        <div class="all-video-buttons center-flex-y">
          <span>{{timestampToDate(item.timestamp)}}</span>
          <span>{{item.title}}</span>
        </div>
        <button @click="executeRemoveVideo(item)">Remove</button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
import VueFirestore from "vue-firestore";
require("firebase/firestore");
Vue.use(VueFirestore);
var firestore;

import moment from "moment";

import request from "axios";

import IcFirebaseUploader from "ic-firebase-uploader";
import "ic-firebase-uploader/dist/ic-firebase-uploader.min.css";

import gridX from "../widgets/gridX";

export default {
  props: [],
  components: { "ic-firebase-upload": IcFirebaseUploader, gridX },
  data: function() {
    firestore = firebase.firestore();
    return {
      storage: firebase.storage(),
      editVideo: {},
      editVideoMode: false,
      videoEpisodes: [],
      newVideo: {
        key: "",
        obj: {
          id: "",
          title: ""
        }
      },
      selectedVideo: "",
      showNewVideo: false
    };
  },
  firestore() {
    return {
      // Collection
      videos: firestore.collection("videos")
    };
  },
  methods: {
    executeRemoveVideo: function(item) {
      firestore
        .collection("videoEpisodes")
        .doc(item[".key"])
        .delete();
    },
    editVideoItem: function(item) {
      this.editVideoMode = true;
      this.editVideo = { key: item[".key"], obj: item };
      console.log(this.editVideo);
      this.$binding(
        "videoEpisodes",
        firestore
          .collection("videoEpisodes")
          .where("playlist", "==", item[".key"])
          .orderBy("timestamp", "desc")
      );
    },
    onUploadedVideoSocialImage: function(e) {
      console.log(e);
      e.getDownloadURL().then(url => {
        this.editVideo.obj.socialImage = url;
        this.$firestore.videos.doc(this.editVideo.key).update({
          socialImage: url
        });
      });
    },
    onUpload: function(e) {
      e.doUpload();
    },
    onDelete: function(e) {
      e.doDelete();
    },
    getFileName: function(file) {
      return file.name + Math.floor(Math.random() * 1000);
    },
    updateCacheVideo: function() {
      this.videos.forEach(video => {
        request
          .get("https://cdn.jwplayer.com/v2/playlists/" + video.id)
          .then(response => {
            var playlist = [];

            setTimeout(function() {
              firestore
                .collection("videoEpisodes")
                .where("playlist", "==", video[".key"])
                .get()
                .then(function(snap) {
                  firestore
                    .collection("videos")
                    .doc(video[".key"])
                    .update({
                      latest: response.data.playlist[0],
                      count: snap.size
                    });
                });
            }, 5000);

            response.data.playlist.forEach(function(playlistItem) {
              var dataObj = {
                playlist: video[".key"],
                timestamp: playlistItem.pubdate,
                duration: playlistItem.duration,
                pubdate: playlistItem.pubdate,
                mediaid: playlistItem.mediaid,
                title: playlistItem.title,
                image: playlistItem.image,
                description: playlistItem.description
              };

              firestore
                .collection("videoEpisodes")
                .doc(video[".key"] + "-" + playlistItem.mediaid)
                .get()
                .then(function(data) {
                  if (data.exists) {
                    firestore
                      .collection("videoEpisodes")
                      .doc(video[".key"] + "-" + playlistItem.mediaid)
                      .update(dataObj);
                  } else {
                    firestore
                      .collection("videoEpisodes")
                      .doc(video[".key"] + "-" + playlistItem.mediaid)
                      .set(dataObj);
                  }
                });
            });
          });
      });
    },
    timestampToDate: function(timestamp) {
      return moment.unix(timestamp).format("YYYY-MM-DD");
    },
    removeVideoItem: function(item) {
      this.$firestore.videos.doc(item[".key"]).delete();
    },
    createVideo: function() {
      var errorMessage = "";
      if (!this.newVideo.key) {
        errorMessage = "Missing key";
      }
      if (!this.newVideo.obj.id) {
        errorMessage = "Missing RSS";
      }
      if (!this.newVideo.obj.title) {
        errorMessage = "Missing Title";
      }
      if (errorMessage) {
        alert(errorMessage);
        return;
      }
      this.$firestore.videos.doc(this.newVideo.key).set(this.newVideo.obj);
      this.newVideo = {
        key: "",
        obj: {
          id: "",
          title: ""
        }
      };
    },
    executeEditVideo: function() {
      var errorMessage = "";
      if (!this.editVideo.key) {
        errorMessage = "Missing key";
      }
      if (!this.editVideo.obj.id) {
        errorMessage = "Missing RSS";
      }
      if (!this.editVideo.obj.title) {
        errorMessage = "Missing Title";
      }
      if (errorMessage) {
        alert(errorMessage);
        return;
      }
      this.$firestore.videos.doc(this.editVideo.key).set(this.editVideo.obj);
      this.editVideo = {
        key: "",
        obj: {
          id: "",
          title: ""
        }
      };
      this.editVideoMode = false;
    },
    selected: function() {
      this.$refs.videoSelector.style.setProperty("--inputColor", "aliceblue");
    },
    changeColor: function() {
      this.$refs.videoSelector.style.setProperty("--inputColor", "black");
    }
  }
};
</script>
<style scoped>
.draggable-items {
  justify-content: space-between;
  padding-left: 0.5em;
}

.edit-video {
  margin-top: 1.5em;
}

.social-image-title {
  margin-top: 0;
}

.all-video-buttons span:first-of-type {
  margin-right: 1em;
}
</style>



// WEBPACK FOOTER //
// videos.vue?5c200cfb